import { TimelineLite, Power2, gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import debounce from 'lodash.debounce';
import imagesLoaded from 'imagesloaded';

gsap.registerPlugin( ScrollTrigger );




function reveal() {


    // const negateItems = document.querySelectorAll('.place-to-belong-wrapper .wp-block-button__link');
    // negateItems.forEach((item) => {
    //     item.classList.add('no-gsap-effect')
    // })

    const revealContainers = document.querySelectorAll('.entryContent .wp-block-button__link:not(.no-gsap-effect)');
    revealContainers.forEach((container) => {


        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            toggleActions: 'play reset play reset',
          },
        })

        // tl.set(container, { autoAlpha: 1 })

        tl.from(container, 0.24, {
          xPercent: -3,
          yPercent: -20,
          opacity: 0.3,
          ease: Power2.out,
        })

        // tl.from(container, 0.33, {
        //   delay: -0.23,
        //   scale: 1.5,
        //   ease: Power2.out,
        // })
      })
}



  function refreshScroll() {
    ScrollTrigger.refresh()
  }

  function initEvents() {
  }


function init() {
    reveal()
}

export default {
  init,
}
